import { useState } from 'react';
import { Button, Space, Typography } from 'antd';
import { useListTrackedCardsQuery } from '../../../redux/api/kit-staging';
import { StatusLegendPopup } from '../../../components/KitStaging/StatusLegendPopup';
import { CartRouteView } from '../../../components/KitStaging/CartRouteView';
import { BoardView } from './BoardBase';
import { groupByOli, OliGroup } from './groupByOli';

interface Props {
	view?: BoardView;
	selectedGroup?: OliGroup | null;
	onSelect?: (g: OliGroup | null) => void;
}

/** Cart board — the delivery-route view. Stops are ordered by destination
 *  route_order; tapping a stop selects the OLI group, which drives the shared
 *  left sidebar (detail + deliver/confirm/reroute actions). The `view` prop is
 *  accepted for parity. */
export const CartBoard = ({ selectedGroup = null, onSelect }: Props = {}) => {
	const { data: cards } = useListTrackedCardsQuery({}, { pollingInterval: 10000 });
	const [legendOpen, setLegendOpen] = useState(false);

	const cartCount = groupByOli(cards ?? []).filter(
		(g) => g.kitCard?.current_area === 'cart' || g.materialCard?.current_area === 'cart',
	).length;

	// CartRouteView forwards the tapped group without toggling, so re-tapping the
	// active stop should clear the sidebar — toggle here.
	const select = (g: OliGroup | null) =>
		onSelect?.(g == null ? null : selectedGroup?.oli === g.oli ? null : g);

	return (
		<div style={{ padding: 16, width: '100%' }}>
			<Space style={{ justifyContent: 'space-between', width: '100%' }}>
				<Typography.Title level={3} style={{ margin: 0 }}>
					Cart{' '}
					<Typography.Text type="secondary" style={{ fontSize: 14 }}>
						({cartCount})
					</Typography.Text>
				</Typography.Title>
				<Button onClick={() => setLegendOpen(true)} aria-label="Show status legend">
					?
				</Button>
			</Space>

			<div style={{ marginTop: 12 }}>
				<CartRouteView onSelect={select} selectedGroup={selectedGroup} />
			</div>

			<StatusLegendPopup open={legendOpen} onClose={() => setLegendOpen(false)} />
		</div>
	);
};
